export default "__VITE_ASSET__ByxzGvQe__"